import { PAYMENT_STEPS } from '../components/payments/integrated-payment/integrated-payment-steps.constant'

/**
 * Check if the step is one of the PAYMENT_STEPS values expected from payment gateway
 * @return boolean indicating whether the step is a payment gateway step
 */
export function isPaymentStep(step: string): boolean {
  return (
    Object.values(PAYMENT_STEPS).includes(step as PAYMENT_STEPS) &&
    step !== PAYMENT_STEPS.DISMISSED
  )
}

/**
 * Validate if an event origin matches with a source URL.
 * @return boolean indicating if the event origin matches
 */
export function validateEventOrigin(
  eventOrigin: string,
  sourceURL: string,
  currentWindowURL: string
): boolean {
  // if gatewaySrc is a relative path
  // check event origin is current store's base url
  if (sourceURL.startsWith('/')) {
    return eventOrigin === new URL(currentWindowURL).origin
  }

  if (sourceURL.startsWith('https://') || sourceURL.startsWith('http://')) {
    return eventOrigin === new URL(sourceURL).origin
  }

  // if gatewaySrc is a non-http(s) prefix pointing to mobile payment integrator
  // bypass event origin validation
  if (sourceURL.indexOf('://') !== -1) {
    return true
  }

  // if gatewaySrc starts with an IP address
  // allow either http:// or https:// prefixed event origins
  if (startsWithIP(sourceURL)) {
    return (
      eventOrigin === new URL(`http://${sourceURL}`).origin ||
      eventOrigin === new URL(`https://${sourceURL}`).origin
    )
  }

  try {
    // if `https://${gatewaySource}` is a valid URL, check if it matches with event origin
    return eventOrigin === new URL(`https://${sourceURL}`).origin
  } catch (e) {
    // if `https://${gatewaySource}` is not a valid URL, return false
    // as the retailer should not be able to use integration payment at this stage
    return false
  }
}

// checks if a string starts with an IP address. e.g. 192.168.1.3 or 10.2.112.19/pay will both return true
export function startsWithIP(str: string): boolean {
  return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/.test(
    str
  )
}
